module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_18_B.60a879ce.mp3";